<template>
  <section @click="toggle">
      <div class="document" v-if="isGreen" >
          <img class="documentIcon" src="@/assets/Upload/greenFolder.svg"/>
          <p>{{this.folder.title}}</p>
      </div>
      <div class="document" v-if="isRed" >
          <img class="documentIcon" src="@/assets/Upload/tmpRed.svg"/>
          <p>{{this.folder.title}}</p>
      </div>
      <div class="document" v-if="isBlue" >
          <img class="documentIcon" src="@/assets/Upload/blueFolder.svg"/>
          <p>{{this.folder.title}}</p>
      </div>
      <div class="document" v-if="isOrange" >
          <img class="documentIcon" src="@/assets/Upload/orangeFolder.svg"/>
          <p>{{this.folder.title}}</p>
      </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: ["folder", "details"],

    computed: {
        ...mapState("upload", ["isAddingFolder", "isShowingDetails"]),
        isGreen(){
            if(this.folder.color == "green"){
                return true;
            }
            return false;
        },   
        isRed(){
            if(this.folder.color == "red"){
                return true;
            }
            return false;
        },   
        isBlue(){
            if(this.folder.color == "blue"){
                return true;
            }
            return false;
        },   
        isOrange(){
            if(this.folder.color == "orange"){
                return true;
            }
            return false;
        }   
    },

    methods: {
        toggle(){
            this.folder.showDetails = true;
        }
    },
}
</script>

<style  scoped>
p{
    color: gray;
    font-size: 15px;
}
.document{
    display: flex;
    width: 150px;
    flex-direction: column;
    text-align: center;
    margin: 15px;
    cursor: pointer;    
}
.documentIcon{
    height: 200px;
    width: 150px;
}
.plus{
    font-size: 25px;
    background-color: #11cdc4;
    width: 38px;
    align-self: center;
    border-radius: 20vw;
    color: white;
}
</style>